<div {...$$restProps}>
  <slot />
</div>

<style lang="postcss">
  div {
    @apply flex flex-row text-center;
    --text-gap: 12px;
  }

  div::before,
  div::after {
    @apply flex-grow flex-shrink border-b border-solid border-light-100;
    content: "";
    margin: auto;
    min-width: 10px;
  }

  div::before {
    margin-right: var(--text-gap);
  }

  div::after {
    margin-left: var(--text-gap);
  }
</style>